var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1390,
    height: 1024,
    viewBox: "0 0 1390 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1149.462 140.728h-28.811c-14.409-50.425-57.629-86.442-108.054-86.442h-864.413c-64.831 0-115.255 50.424-115.255 115.256v288.138c0 302.545 244.918 547.464 547.464 547.464 273.733 0 497.039-201.699 540.259-461.022h28.811c108.054 0 194.494-86.442 194.494-194.493s-86.44-208.9-194.494-208.9zM1012.597 169.541v288.138c0 237.714-194.494 432.206-432.205 432.206-237.715 0-432.208-194.491-432.208-432.206v-288.138h864.413zM1149.462 428.866h-21.606v-180.086h21.606c50.425 0 86.448 43.221 86.448 86.442s-36.023 93.645-86.448 93.645z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCup);
export default __webpack_public_path__ + "static/media/icon-cup.ccb91a4cde29c52a85bd3fbbdeda0a0d.svg";
export { ForwardRef as ReactComponent };